// @core/api/endpoints/affiliate/suspend_affiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
  SuspendAffiliateRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Suspend affiliate
 * Performs suspend operation on affiliate.
 */
export async function SuspendAffiliate(
  affiliate_id: string,
  data: SuspendAffiliateRequest,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id/suspend`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.post<AffiliateResponse>(requestPath, data, requestOptions);
}
